"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var makeMq = function makeMediaQuery(_ref) {
  var md = _ref.md,
      lg = _ref.lg;
  return function checkMQ(width, mq) {
    // console.log('width ', width);
    switch (mq) {
      case 'sm':
        // console.log('sm ', width <= md);
        return width <= md;

      case 'md+':
        // console.log('md+ ', width > md);
        return width > md;

      case 'md-':
        // console.log('md- ', width <= lg);
        return width <= lg;

      case 'md':
        // console.log('md ', width > md && width <= lg);
        return width > md && width <= lg;

      case 'lg':
        // console.log('lg ', width > lg);
        return width > lg;

      default:
        console.warn('Media query problem ', mq);
        return false;
    }
  };
};

var _default = makeMq;
exports.default = _default;